import type { RouteLocationNormalized } from 'vue-router'
import { APP_HOME_TITLE, APP_TITLE_SUFFIX } from '@/constants/routes'

function normalizeTitle(title?: string | null) {
  return title?.trim() ?? ''
}

export function formatPageTitle(title?: string | null) {
  const normalizedTitle = normalizeTitle(title)

  if (!normalizedTitle) {
    return APP_HOME_TITLE
  }

  return `${normalizedTitle} - ${APP_TITLE_SUFFIX}`
}

export function resolveRoutePageTitle(route: RouteLocationNormalized) {
  const routeTitle = normalizeTitle(String(route.meta.title ?? ''))

  if (route.meta.fullTitle === true) {
    return routeTitle || APP_HOME_TITLE
  }

  return formatPageTitle(routeTitle)
}

export function applyDocumentTitle(title?: string | null) {
  if (typeof document === 'undefined') {
    return
  }

  document.title = formatPageTitle(title)
}
